import { ModuleModel } from '../../module.model.interface';
import { ApiProfileDescriptor } from './api.profile';

export class ProfileModel extends ApiProfileDescriptor implements ModuleModel {
  public discriminator = 'ProfileDescriptor';

  constructor(options?: {
    id?: string;
    userName?: string;
    fullName?: string;
    emailAddress?: string;
    phoneNumber?: string;
    baseRoleType?: string;
    mandatoryUpdate?: boolean;
    calendarEventNotificationByEmail?: boolean;
    calendarEventNotificationBySms?: boolean;
    modified?: Date;
    deleted?: Date;
    href?: string;
  }) {
    super();
    if (options) {
      if (options.id) { this.id = options.id; }
      if (options.userName) { this.userName = options.userName; }
      if (options.fullName) { this.fullName = options.fullName; }
      if (options.emailAddress) { this.emailAddress = options.emailAddress; }
      if (options.phoneNumber) { this.phoneNumber = options.phoneNumber; }
      if (options.baseRoleType) { this.baseRoleType = options.baseRoleType; }
      if (options.mandatoryUpdate) { this.mandatoryUpdate = options.mandatoryUpdate; } else { this.mandatoryUpdate = false; }
      if (options.calendarEventNotificationByEmail) { this.calendarEventNotificationByEmail = options.calendarEventNotificationByEmail; } else { this.calendarEventNotificationByEmail = false; }
      if (options.calendarEventNotificationBySms) { this.calendarEventNotificationBySms = options.calendarEventNotificationBySms; } else { this.calendarEventNotificationBySms = false; }
      if (options.modified) { this.modified = options.modified; } else { this.modified = null; }
      if (options.deleted) { this.deleted = options.deleted; } else { this.deleted = null; }
      if (options.href) { this.href = options.href; }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/profile/model/profile.model.ts